import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";
import { KeyboardArrowDown } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import useVendorAccessGate from "../../../hooks/useVendorAccessGate";
import { vendorMainColumnMaxWidthSx } from "../../../config/vendorContentMaxWidth";

const DettaglioMovimenti = () => {

  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  useVendorAccessGate();
  const navigate = useNavigate();

  useEffect(() => {
    fetchBudgetData().then((data) => {
      setTransactions(data);
      setLoading(false);
    });
  }, []);

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={2}
      sx={{ width: "100%", fontFamily: "Rubik", ...vendorMainColumnMaxWidthSx }}
    >

        <Box display="flex" alignItems="center" onClick={() => navigate("/gestioneBudget")} sx={{ cursor: "pointer" }}>
            <Typography variant="body1" sx={{ fontWeight: "bold", fontFamily: "Rubik", color: "#0b3d87", ml: 1 }}>⬅ Riepilogo Movimenti</Typography>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "space-between" }}>

          <Typography variant="h4" sx={{ fontFamily: "Rubik", fontWeight: "bold", color: "#0b3d87" }}>
            Dettaglio Movimento
          </Typography>
          
          <Box display="flex" justifyContent="flex-end">
            <Button
              onClick={() => navigate("/ricarica")}
              variant="contained"
              sx={{
                backgroundColor: "#0b3d87",
                color: "white",
                borderRadius: "20px",
                padding: "6px 20px",
                fontWeight: "bold",
                textTransform: "none",
                "&:hover": { backgroundColor: "#092b6a" },
              }}
            >
              Effettua una Ricarica
            </Button>
          </Box>
        </Box>

        <Typography variant="h7" sx={{ fontFamily: "Rubik", fontWeight: "bold", color: "#0b3d87" }}>
          FILTRA PER
        </Typography>
        <Box display="flex" gap={2} flexWrap="wrap">
          {["Tipo di movimento", "Importo"].map((filter, index) => (
            <Button
              key={index}
              variant="contained"
              endIcon={<KeyboardArrowDown />}
              sx={{
                backgroundColor: "#0b3d87",
                color: "white",
                borderRadius: "7px",
                padding: "6px 15px",
                fontWeight: "bold",
                textTransform: "none",
                fontFamily: "Rubik",
                "&:hover": { backgroundColor: "#092b6a" },
              }}
            >
              {filter}
            </Button>
          ))}
        </Box>

        {/* Transactions Table */}
        <TableContainer
          component={Paper}
          sx={{
            borderRadius: "12px",
            mt: 2,
            boxShadow: 2,
            maxHeight: "600px",
            overflowY: "auto",
          }}
        >
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#0b3d87" }}>
                {["DATA E ORA", "TIPO DI MOVIMENTO", "IMPORTO"].map((header, index) => (
                  <TableCell
                    key={index}
                    sx={{
                      position: "sticky",
                      top: 0,
                      backgroundColor: "#0b3d87",
                      color: "white",
                      fontWeight: "bold",
                      fontFamily: "Rubik",
                      zIndex: 1,
                    }}
                  >
                    {header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={4} align="center" sx={{ fontFamily: "Rubik" }}>Loading...</TableCell>
                </TableRow>
              ) : transactions.length > 0 ? (
                transactions.map((item, index) => (
                  <TableRow key={index} sx={{ backgroundColor: index % 2 === 0 ? "#f0f5ff" : "white" }}>
                    <TableCell sx={{ fontFamily: "Rubik" }}>{item.dateTime}</TableCell>
                    <TableCell sx={{ fontFamily: "Rubik" }}>{item.tipoDiMovimento}</TableCell>
                    {/* <TableCell sx={{ fontFamily: "Rubik" }}>{item.descrizione}</TableCell> */}
                    <TableCell sx={{ fontFamily: "Rubik" }}>{item.importo}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} align="center" sx={{ fontFamily: "Rubik" }}>Nessun movimento disponibile</TableCell>
                </TableRow>
              )}
            </TableBody>
          
          </Table>
        </TableContainer>
    </Box>

  );
};

const fetchBudgetData = async () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve([
        { dateTime: "17 Feb – Ore 17.30", tipoDiMovimento: "aaaaa",  importo: "100 €" },
        { dateTime: "17 Feb – Ore 17.30", tipoDiMovimento: "aaaaa",  importo: "100 €" },
        { dateTime: "17 Feb – Ore 17.30", tipoDiMovimento: "aaaaa",  importo: "100 €" },
        { dateTime: "17 Feb – Ore 17.30", tipoDiMovimento: "aaaaa",  importo: "100 €" },
        { dateTime: "17 Feb – Ore 17.30", tipoDiMovimento: "aaaaa",  importo: "100 €" },
        { dateTime: "17 Feb – Ore 17.30", tipoDiMovimento: "aaaaa",  importo: "100 €" },
        { dateTime: "17 Feb – Ore 17.30", tipoDiMovimento: "aaaaa",  importo: "100 €" },
        { dateTime: "17 Feb – Ore 17.30", tipoDiMovimento: "aaaaa",  importo: "100 €" },
        { dateTime: "17 Feb – Ore 17.30", tipoDiMovimento: "aaaaa",  importo: "100 €" },
        { dateTime: "17 Feb – Ore 17.30", tipoDiMovimento: "aaaaa",  importo: "100 €" },
      ]);
    }, 2000);
  });
};

export default DettaglioMovimenti;
